import React, { memo, useState } from "react"
import Link from "next/link"
import TypeEvent from "utils/TypeEvent"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { Navigation } from "swiper"
import CardBanner from "components/CardBanner"
import Image from "next/legacy/image"

// eslint-disable-next-line react/display-name
const MySwiper = memo(({ name, events, id, type_block, display_type, thumbnail_banner }) => {
  const [srcImage, setSrcImage] = useState(thumbnail_banner)
  return (
    <div className="mb-4 md:mb-4 lg:mb-6 ">
      {type_block === TypeEvent.BANNER && (
        <>
          <div className="relative wapper__play">
            <div className="fix_img mb-2">
              <Image
                className="rounded-lg bg-dark-900"
                src={srcImage}
                width={1280}
                height={427}
                alt={name}
                onError={() => setSrcImage("https://stvinaprod.vtvcab.vn/94f98a7a-6ded-4e15-ac0e-27c26829307c.png")}
              />
            </div>
            {true && (
              <div
                className="absolute shadow left-0 bottom-0  w-full bg-slide-bander hidden md:block"
                style={{ height: "213px" }}
              ></div>
            )}
          </div>
          <div className="mt-1">
            <div>
              <h2 className=" mb-2 md:mb-2 text-sm md:text-lg lg:text-xl font-semibold  ">
                <Link href={`/danh-muc/${id}`}>
                  <div className="text-dark-100 flex items-center wapper_see_more">
                    <span className="uppercase mr-4">{name}</span>{" "}
                    <div className="text-primary-500 text-sm flex items-center see_more">
                      <span>Xem thêm</span>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13 17L18 12L13 7"
                          stroke="#66A7FF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6 17L11 12L6 7"
                          stroke="#66A7FF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </Link>
              </h2>
            </div>
            <Swiper
              key={"banner"}
              spaceBetween={16}
              modules={[Navigation]}
              className="mySwiper"
              navigation={true}
              breakpoints={{
                0: {
                  slidesPerView: 2.5,
                  slidesPerGroup: 2
                },
                768: {
                  slidesPerView: 3.2,
                  slidesPerGroup: 3
                },
                1050: {
                  slidesPerView: 3.6,
                  slidesPerGroup: 3
                },
                1180: {
                  slidesPerView: 4.2,
                  slidesPerGroup: 4
                },
                1280: {
                  slidesPerView: 4.6,
                  slidesPerGroup: 4
                }
              }}
            >
              {events?.length > 0 &&
                events?.map((item) => {
                  const { id } = item
                  return (
                    <SwiperSlide key={id}>
                      <CardBanner
                        {...item}
                        display_type={display_type}
                        //  hideText={true}
                        showTime={false}
                      />
                    </SwiperSlide>
                  )
                })}
            </Swiper>
          </div>
        </>
      )}
    </div>
  )
})

export default MySwiper
